
<div class="user-container">
    <div class="user-inner-container">
        <div class="user-action-container" >
            <div *ngIf="loading" class="loading-container">
                <img src="./assets/icons/loading.gif" alt="Loading">
            </div>
            <div *ngIf="!loading">
                <div class="logo-container">
                    <img src="{{baseHref}}assets/logo.png">
                </div>    
                <div class="user-welcome">WELCOME BACK</div>
                <div class="user-header">Log In To Your Account</div>
                    <!-- app.component.html -->
                <div class="container mt-3">
                    <form (ngSubmit)="onLogin()">
                        <div class="row">
                            <div class="col-12">
                                <label for="username" class="form-label">Username</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    autocomplete="username"
                                    id="username"
                                    placeholder="Enter your username"
                                    [(ngModel)]="username" 
                                    name="username"
                                    required
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 password-container">
                                <label for="password" class="form-label">Password</label>
                                <input
                                    [type]="showPassword ? 'text' : 'password'"
                                    class="form-control"
                                    autocomplete="current-password"
                                    id="password"
                                    placeholder="Enter your password"
                                    [(ngModel)]="password" 
                                    name="password"
                                    required
                                />
                                <mat-icon (click)="togglePasswordVisibility()" aria-hidden="false" aria-label="Example home icon" fontIcon="{{showPassword ? 'visibility_off' : 'visibility'}}"></mat-icon>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 user-remember-container">
                                <input type="checkbox" id="rememberMe" name="remember" checked class="user-remember-checkbox">
                                <label for="rememberMe" class="user-remember">Remember me</label>
                            </div>
                            <div class="col-6 right-align">
                                <a class="user-forgot" routerLink="/password">Forgot Password?</a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button type="submit" class="btn-blue user-continue-button">CONTINUE</button>
                            </div>
                        </div>
                    </form>
                    <div class="user-register-link">
                        Don't have an account? <a class="request-access" routerLink="/request">REQUEST ACCESS</a>
                    </div>
                </div>
            </div>    
        </div>
    </div>
</div>